import './TabGroup.scss';

import * as React from 'react';
import { ComponentProps } from 'react';

import { SlTabGroup } from '@shoelace-style/shoelace/dist/react';

type TabGroupProps = ComponentProps<typeof SlTabGroup>;

/*
 * This component is a wrapper around the SlTabGroup component.
 * It adds a class to the SlTabGroup component and passes through the rest of the props.
 */
export function TabGroup({ children, ...props }: TabGroupProps) {
  return <SlTabGroup {...props}>{children}</SlTabGroup>;
}
